module.exports = __webpack_public_path__ + "static/media/04.51eda76a.jpg";